import EmailTemplateDrawer, {
  EmailTemplateDrawerDataType,
} from './email-template-drawer.component';
import { useGlobalDrawer } from 'components/drawers/global-drawer/global-drawer.hooks';
import { useEmailTemplateForm } from 'components/forms/email-template-form/email-template-form.hooks';
import { useTranslation } from 'react-i18next';
import { IncDrawerType } from 'components/drawers/inc-drawer/inc-drawer.component';
import { Alert } from '@mui/material';

type CreateEmailTemplateDrawerProps =
  IncDrawerType<EmailTemplateDrawerDataType>;

const CreateEmailTemplateDrawer = ({
  isOpen,
  close,
  data: drawerData,
  ...rest
}: CreateEmailTemplateDrawerProps) => {
  const { t } = useTranslation();
  const { form } = useEmailTemplateForm(drawerData?.template);
  const {
    drawerProps: { open: openEmailEditorDrawer },
  } = useGlobalDrawer('globalCreateEmailEditorDrawer');

  const cancel = () => {
    form.reset();
    close();
  };

  const submitHandler = data => {
    openEmailEditorDrawer({
      ...drawerData,
      template: { ...drawerData?.template, ...data },
    });
    cancel();
  };

  return (
    <EmailTemplateDrawer
      isOpen={isOpen}
      close={cancel}
      formMethods={form}
      submitHandler={submitHandler}
      title={t('drawer.createEmailTemplateDrawer.title')}
      submitButtonLabel={t(
        'drawer.createEmailTemplateDrawer.submitButtonLabel',
      )}
      subtitle={
        drawerData?.oneOff ? (
          <Alert severity="info">
            {t('drawer.createEmailTemplateDrawer.alert')}
          </Alert>
        ) : null
      }
      {...rest}
    />
  );
};

export default CreateEmailTemplateDrawer;
